// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { FreebetsIcon } from '../../../../assets/img/betting';
import Formatter from '../../../../i18n/formatter';
import { __, getCurrency, getLang } from '../../../../i18n/l10n';
import { BoomAssetsBySkinId } from '../../constants/assets';
import BoomUIBySkinId from '../../constants/ui';
import { type BoomSkinId } from '../../types/global';
import BoomRulesButtonContainer from '../BoomRulesButton/BoomRulesButtonContainer';
import BoomBoxWrapper from '../common/BoomBoxWrapper';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;

  flex: 1;
`;

const StyledBoomBoxWrapper = styled(BoomBoxWrapper)`
  margin-top: 0.7em;
  width: auto;

  padding: 0.7em 0.7em 0.3em;
`;

const TotalWinningsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const TotalWinningsLabel = styled.div`
  padding: 0.1em 0.3em;
  border-radius: 0.4em;
  font-size: 1.1em;
  width: auto;

  ${({ $isSuccess, $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE ?? {};

    return $isSuccess
      ? css`
          background-color: ${textStyle.wonBgColor};
          color: ${textStyle.wonColor};
        `
      : css`
          background-color: ${textStyle.pendingBgColor};
          color: ${textStyle.pendingColor};
        `;
  }}
`;

const TotalWinningsValue = styled.div`
  font-weight: bold;
  font-size: 1.9em;
  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE ?? {};

    return css`
      color: ${textStyle.color};
    `;
  }}

  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoWrapper = styled.div`
  flex: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  height: 8em;
`;

const TotalWinningsIcon = styled.img`
  height: 0.8em;
  margin-left: 0.2em;
  margin-top: 0.1em;
  width: auto;
`;

const StyledBoomRulesButton = styled(BoomRulesButtonContainer)`
  font-size: 1.2em;
`;

type PropsType = {
  className?: string;
  totalWon: number;
  isCompleted: boolean;
  skinId: BoomSkinId;
  maxWinnings?: number;
};

const BoomHeader = ({ className = '', totalWon, isCompleted, skinId, maxWinnings = 200 }: PropsType) => {
  const totalWinningsTitle = useMemo(
    () => (
      <TotalWinningsLabel $skinId={skinId} $isSuccess={totalWon !== 0}>
        {totalWon !== 0 ? __('Total winnings') : __('Win up to')}
      </TotalWinningsLabel>
    ),
    [totalWon, skinId],
  );

  const srcLogo = useMemo(
    () => BoomAssetsBySkinId[skinId]?.Logo[getLang()] ?? BoomAssetsBySkinId[skinId]?.Logo?.Full,
    [skinId],
  );

  return (
    <Wrapper className={className}>
      <LogoWrapper>
        <Logo src={srcLogo} />
      </LogoWrapper>
      <ContentWrapper>
        <StyledBoomRulesButton />
        <StyledBoomBoxWrapper isSmall="small" isSuccess={isCompleted}>
          <TotalWinningsWrapper>
            {totalWinningsTitle}
            <TotalWinningsValue $skinId={skinId}>
              {Formatter.formatNumber(totalWon === 0 ? maxWinnings : totalWon, getCurrency(), true)}
              <TotalWinningsIcon src={FreebetsIcon} />
            </TotalWinningsValue>
          </TotalWinningsWrapper>
        </StyledBoomBoxWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};

export default BoomHeader;
